import store from '@/store/store';

export default {
  path: 'referrals/:id/_edit',
  name: 'app-edit-referral',
  component: () => import('@/views/app/edit_referral/EditReferral.vue'),
  meta: {
    pageTitle: ''
  },
  beforeEnter: async (to, from, next) => {
    to.meta.pageTitle = 'edit_referral.header_title';

    const prepareReferralCreateResource = await store.state.router.privateRoot.$request().$get('referral-send');
    store.commit('router/updateRouteProp', {
      property: 'prepareReferralCreateResource',
      value: prepareReferralCreateResource
    });

    let sourceReferralResource = null;
    if (to.params.id) {
      sourceReferralResource = await prepareReferralCreateResource.$request().$get('referral', {id: to.params.id});
      if (!sourceReferralResource.$hasLink('edit')) {
        sourceReferralResource = null;
      }
    }
    store.commit('router/updateRouteProp', {
      property: 'sourceReferralResource',
      value: sourceReferralResource
    });

    next();
  },
  props: () => ({
    prepareReferralCreateResource: store.state.router.prepareReferralCreateResource,
    sourceReferralResource: store.state.router.sourceReferralResource
  })
};
